import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueAsyncComputed from 'vue-async-computed'
import VueSimpleAlert from "vue-simple-alert";
import VueLodash from 'vue-lodash'
import UUID from 'vue-uuid';
import lodash from 'lodash'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'

// Vuetify default values
Vue.use(Vuetify);
Vue.use(UUID);
Vue.use(VueAsyncComputed);
Vue.use(VueSimpleAlert, {width: "300px"});
Vue.use(VueLodash, {name: "custom", lodash: lodash});

export default new Vuetify({});
